import React from 'react';
import { ArrowRightIcon } from '@phosphor-icons/react';
import { MPFSectionHeading } from 'volto-ministerio-publico-federal/components/UI';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';

interface LinkItem {
  '@id'?: string;
  '@type'?: string;
  title?: string;
  getRemoteUrl?: string;
  [key: string]: unknown;
}

interface LinksProps {
  items?: LinkItem[];
  listClassName?: string;
  title?: string;
}

export const Links: React.FC<LinksProps> = ({
  items = [],
  listClassName = 'mpf__links-list',
  title,
}) => {
  const links = items.filter(
    (item) => item['@type'] === 'Link' || item['@type'] === 'Folder',
  );

  if (links.length === 0) {
    return null;
  }

  return (
    <div className="mpf__links">
      {title && <MPFSectionHeading title={title} />}

      <ul className={listClassName}>
        {links.map((item, index) => {
          if (!item['@id']) {
            return null;
          }

          return (
            <li key={index} className="mpf__link-item">
              <UniversalLink
                item={{
                  '@id': item['@id'],
                  '@type': item['@type'],
                  remoteUrl: item.getRemoteUrl,
                }}
                className="mpf__link-row"
                title={item.title}
              >
                <span className="mpf__link-title">{item.title}</span>

                <span className="mpf__link-arrow" aria-hidden="true">
                  <ArrowRightIcon size={18} />
                </span>
              </UniversalLink>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Links;
